// extracted by mini-css-extract-plugin
export default {"mainDiv":"NotFound_mainDiv__+lpLk","subDiv":"NotFound_subDiv__eG7xO","nextBtn":"NotFound_nextBtn__HcdjN"};